import React, { useState } from 'react';
import classNames from 'classnames';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { array, bool } from 'prop-types';
import { formatMoney } from '../../util/currency';
import { removeCartItem } from '../../containers/CartPage/CartPage.duck';
import { IconSpinner, ResponsiveImage } from '../index';
import { FormattedMessage, useIntl } from 'react-intl';
import { DISPLAY_CURRENCY } from '../../util/constants/listing';
import defaultConfig from '../../config/configDefault';
import { LISTING } from '../../util/fetchData';
import { types as sdkTypes } from '../../util/sdkLoader';
import { createSlug } from '../../util/urlHelpers';

import NamedLink from '../NamedLink/NamedLink';

import css from './CartInfoPanel.module.css';
const { Money } = sdkTypes;

const CartMobile = ({ listItems, isHideRemoveButton, layout }) => {
    const intl = useIntl();
    const location = useLocation();
    const dispatch = useDispatch();
    const variantPrefix = 'default';
    const [isRemovingItem, setIsRemovingItem] = useState(null);
    const isCheckout = layout === 'checkout';

    const generateDisPlayPrice = price => {
        return formatMoney(intl, new Money(price.amount, price.currency), DISPLAY_CURRENCY);
    };

    const defaultMoney = {
        amount: 0,
        currency: defaultConfig.currency,
    };

    const handleClickRemove = (listingId) => {
        setIsRemovingItem({ [listingId]: true })
        dispatch(removeCartItem(listingId)).then(() => {
            setIsRemovingItem({ [listingId]: false })
        });
    };

    return (
        <div className={css.cartMobileWrapper}>
            {listItems.map(cartItem => {
                const id = LISTING(cartItem).getId();
                const { title, price = defaultMoney } = LISTING(cartItem).getAttributes();
                const { originalPrice = price, discount } = LISTING(cartItem).getPublicData();
                const params = { id, slug: createSlug(title) };





                // seller
                const priceMain = originalPrice
                const { activeSale, date, saleDiscount } = cartItem?.author?.attributes?.profile?.publicData || {}
                const discountedPrice = activeSale ? priceMain?.amount - (priceMain?.amount * parseFloat(saleDiscount) / 100) : 0
                // end

                const displayPrice = generateDisPlayPrice(originalPrice);
                const displayYouPayPrice = generateDisPlayPrice(activeSale ? new Money(discountedPrice, price.currency) : price);

                const firstImage =
                    cartItem.images && cartItem.images.length > 0 ? cartItem.images[0] : null;
                const variants = firstImage
                    ? Object.keys(firstImage?.attributes?.variants).filter(k => k.startsWith(variantPrefix))
                    : [];

                const priceClasses = classNames(css.price, {
                    [css.priceWithDiscount]: (originalPrice.amount !== price.amount || activeSale),
                    [css.priceCheckout]: isCheckout,
                });

                const youPayPriceClassed = classNames(css.payPrice, {
                    [css.youPayPriceWithDiscount]: (originalPrice.amount !== price.amount || activeSale),
                    [css.priceCheckout]: isCheckout,
                });

                const isRemoving = isRemovingItem?.hasOwnProperty(id) ? isRemovingItem[id] : false;

                return (
                    <div className={css.mobileRow} key={`${id}-cart-mobile`}>
                        <div className={classNames(css.imageWrapper, { [css.imageWrapperCheckout]: isCheckout })}>
                            <ResponsiveImage
                                rootClassName={css.rootForImage}
                                alt={title}
                                image={firstImage}
                                variants={variants}
                            />
                        </div>
                        <div className={css.mobileItemInfo}>
                            <NamedLink
                                className={classNames(css.listingTitle, { [css.listingTitleCheckout]: isCheckout })}
                                name="ListingPage"
                                params={params}
                                to={{ search: `from=${location.pathname}${location.search}` }}
                                target="_blank"
                            >
                                {title}
                            </NamedLink>
                            <div>
                                <span className={priceClasses}>{displayPrice}</span>
                                <span className={youPayPriceClassed}>{displayYouPayPrice}</span>
                            </div>
                            {!isHideRemoveButton && (
                                <div>
                                    <span
                                        className={css.removeFromCartButton}
                                        onClick={() => handleClickRemove(id)}
                                    >
                                        {isRemoving ? (
                                            <IconSpinner />
                                        ) : (
                                            <FormattedMessage id='CartInfoPanel.removeButton' />
                                        )}
                                    </span>
                                </div>
                            )}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

CartMobile.defaultProps = {
    listItems: [],
    isHideRemoveButton: false,
};

CartMobile.propTypes = {
    listItems: array,
    isHideRemoveButton: bool,
};

export default CartMobile;
